"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var UserDetail_1 = __importDefault(require("@features/ItemCommon/components/fieldsGroup/UserDetail"));
var LocationDetail_1 = __importDefault(require("@features/ItemCommon/components/fieldsGroup/LocationDetail"));
var ItemHistory_1 = __importDefault(require("@features/ItemCommon/components/ItemHistory"));
var UserAgent_1 = __importDefault(require("@features/ItemCommon/components/fieldsGroup/UserAgent"));
function OtherInformation(props) {
    var job = props.job, domain = props.domain, angularJsDependencies = props.angularJsDependencies, editPermissions = props.editPermissions, updateItemCustomerSpecific = props.updateItemCustomerSpecific, updateItemCurrent = props.updateItemCurrent, template = props.template, automationListsPermission = props.automationListsPermission, editMode = props.editMode;
    var _a = __read(react_1.default.useState(job), 2), localJob = _a[0], setLocalJob = _a[1];
    var updateCustomerSpecific = function (scope, key, value) {
        var _a, _b;
        if ((_a = localJob === null || localJob === void 0 ? void 0 : localJob.ad) === null || _a === void 0 ? void 0 : _a.customerSpecific) {
            var newJob = Object.assign(Object.create(Object.getPrototypeOf(localJob)), localJob);
            if ((_b = newJob === null || newJob === void 0 ? void 0 : newJob.ad) === null || _b === void 0 ? void 0 : _b.customerSpecific) {
                newJob.ad.customerSpecific[scope][key] = value;
                setLocalJob(newJob);
                updateItemCustomerSpecific(newJob.ad.customerSpecific);
            }
        }
    };
    var updateUsername = function (val) {
        var _a, _b, _c, _d;
        if ((_b = (_a = localJob === null || localJob === void 0 ? void 0 : localJob.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.user) {
            var newJob = Object.assign(Object.create(Object.getPrototypeOf(localJob)), localJob);
            if ((_d = (_c = newJob === null || newJob === void 0 ? void 0 : newJob.ad) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.user) {
                newJob.ad.current.user.name = val;
                setLocalJob(newJob);
                updateItemCurrent(newJob.ad.current);
            }
        }
    };
    (0, react_1.useEffect)(function () {
        setLocalJob(job);
    }, [editMode, job]);
    return (react_1.default.createElement("div", { className: "eva-job-other-information" },
        react_1.default.createElement(UserDetail_1.default, { job: localJob, domain: domain, updateUsername: updateUsername, editPermissions: editPermissions, updateCustomerSpecific: updateCustomerSpecific, angularJsDependencies: angularJsDependencies, templateIndex: template.user_details_index, automationListsPermission: automationListsPermission, editMode: editMode }),
        react_1.default.createElement(LocationDetail_1.default, { job: localJob, domain: domain, updateCustomerSpecific: updateCustomerSpecific, editPermissions: editPermissions, angularJsDependencies: angularJsDependencies, templateIndex: template.location_details_index, automationListsPermission: automationListsPermission, editMode: editMode }),
        react_1.default.createElement(ItemHistory_1.default, { job: localJob, domain: domain, angularJsDependencies: angularJsDependencies, templateIndex: template.item_details_index, automationListsPermission: automationListsPermission }),
        react_1.default.createElement(UserAgent_1.default, { job: localJob, domain: domain, templateIndex: template.user_agent_index })));
}
exports.default = OtherInformation;
